import { ButtonBase } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import usePinnedEntities, { PinSource } from "catalog/hooks/usePinnedEntities";
import { PinIcon } from "~/assets/icons";

type PinButtonProps = {
  fqn: string;
  showPin: boolean;
  source: PinSource;
};

const PinButton = ({ fqn, showPin, source }: PinButtonProps) => {
  const theme = useTheme();
  const { isPinned, addEntities, removeEntities } = usePinnedEntities();
  const pinned = isPinned(fqn);

  return (
    <ButtonBase
      sx={{
        height: "fit-content",
        "&:hover": {
          path: {
            fill: pinned ? theme.palette.primary.main : "#000",
          },
        },
      }}
      onClick={() => {
        if (pinned) {
          removeEntities([fqn], source);
        } else {
          addEntities([fqn], source);
        }
      }}
    >
      {(showPin || pinned) && (
        <PinIcon
          width={20}
          height={20}
          color={pinned ? theme.palette.primary.main : theme.palette.grey[400]}
        />
      )}
    </ButtonBase>
  );
};

export default PinButton;
